'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'circle-3';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f0';
var svgPathData = ['M48 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm128-88c0-13.3 10.7-24 24-24l76 0c37.6 0 68 30.4 68 68 0 16.8-6.1 32.1-16.2 44 10.1 11.9 16.2 27.2 16.2 44 0 37.6-30.4 68-68 68l-76 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l76 0c11 0 20-9 20-20s-9-20-20-20l-52 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l52 0c11 0 20-9 20-20s-9-20-20-20l-76 0c-13.3 0-24-10.7-24-24z', 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm20-280l-52 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52 0c11 0 20 9 20 20s-9 20-20 20l-76 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l76 0c37.6 0 68-30.4 68-68 0-16.8-6.1-32.1-16.2-44 10.1-11.9 16.2-27.2 16.2-44 0-37.6-30.4-68-68-68l-76 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l76 0c11 0 20 9 20 20s-9 20-20 20z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle3 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;